import { makeStyles } from "@material-ui/core";
import { wellColors } from "@welldigital/components";

export const useStyles = makeStyles(() => ({
  description: {
    color: wellColors.elixir[400],
  },
}));
